import { ERR_INVALID_ARGUMENT } from "../../../utils/error";
import { serializeGeometries } from "./GeometrySerialization";
import { deserializeLayers, serializeLayers } from "./LayerSerialization";
import { deserializeMaterials, serializeMaterials, serializeTextures } from "./MaterialSerialization";
/** @internal */
export function serializeModel(pModel, pContext) {
    if (pContext == null)
        throw new Error(ERR_INVALID_ARGUMENT);
    var tIOModel = {};
    //elements
    tIOModel.elements = new Array();
    for (var _i = 0, _a = pModel.elements; _i < _a.length; _i++) {
        var tElement = _a[_i];
        var tIOElement = tElement.serialize(pContext);
        if (tIOElement != null)
            tIOModel.elements.push(tIOElement);
    }
    //layers
    tIOModel.layers = serializeLayers(pModel.layers, pContext);
    //geometries
    tIOModel.geometries = serializeGeometries(pModel.geometries, pContext);
    //materials
    tIOModel.materials = serializeMaterials(pModel.materials, pContext);
    //textures
    tIOModel.textures = serializeTextures(pModel.materials, pContext);
    return (tIOModel);
}
/** @internal */
export function deserializeModel(pModel, pIOModel, pContext) {
    if (pIOModel == null || pContext == null)
        return (false);
    //layers
    deserializeLayers(pModel.layers, pIOModel.layers);
    //materials
    deserializeMaterials(pModel.materials, pIOModel.materials, pContext);
    //elements
    for (var _i = 0, _a = pIOModel.elements; _i < _a.length; _i++) {
        var tIOElement = _a[_i];
        var tLoader = pModel.getElementLoader(tIOElement.classId);
        if (tLoader != null) {
            var tElement = tLoader(pModel.app, pContext, tIOElement, null);
            if (tElement != null)
                pModel.addElement(tElement);
        }
    }
    return (true);
}
